<main style="display: grid; place-items: center; width: 100%; heigth: 100%">
    <h1>Connected! Please close this window.</h1>
</main>